<div class="like">
  <div
    role="button"
    class="like__svg-container"
    [innerHTML]="svgHtml | safeHtml"
    [class.like__svg-container--liked]="liked"
    (click)="like()"
    (keyup.enter)="like()"
    (keyup.space)="like()"
  ></div>
</div>
